/**
 * THE PAGE'S ONE COLUMN. Home is phone first, so on a phone the column is the whole width, as every
 * artboard draws it. On a wider screen it is one centred column 42rem wide, in rem so it grows with
 * the text size she has set, and a line, a button or an amount never runs the width of a desk's
 * window: an amount stays beside its words, and a button is a button's width.
 *
 * Every page's `main` is drawn in it. The bars that run the whole width, the header, the footer, the
 * bottom nav and the composer, keep their whole width, their colour and their hairline, with their
 * rows inside the column, so the brand, Call, the footer's links, the tabs and the field line up
 * with the page. A sheet is drawn in it, over the page.
 */
export const COLUMN = 'mx-auto w-full max-w-2xl';
